import apiPasarela from "../apiPasarela";
const dominio = "/administracion";


const getSplit = async (params) => {
    const endpoint = "/split-pago";
    const { data } = await apiPasarela.get(dominio + endpoint, { params });
    return data;
};

const storeSplit = async (payload) => {
    const endpoint = "/split-pago";
    const { data } = await apiPasarela.post(dominio + endpoint, payload);
    return data;
};

const editSplit = async (payload) => {
    const endpoint = "/split-pago";
    const { data } = await apiPasarela.put(dominio + endpoint, payload);
    return data;
};

const desactivarSplit = async (id) => {
    const endpoint = `/disable-split-pago/${id}`;
    const { data } = await apiPasarela.put(dominio + endpoint);
    return data;
}
export default {
    getSplit,
    storeSplit,
    editSplit,
    desactivarSplit
}